import React from 'react';
import { IMaskInput } from 'react-imask';
import TextField from '@mui/material/TextField';
import { toString } from 'lodash';
import { unformatValue } from 'src/utils/check';

// interface CustomProps {
//    onChange: (event: { target: { name: string; value: string } }) => void;
//    name: string;
// }
const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, isUnformat = true, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={Number}
      thousandsSeparator=","
      inputRef={ref}
      onAccept={(value) => {
        let val = isUnformat ? unformatValue(value) : value;
        return onChange({ target: { name: props.name, value: val } });
      }}
    />
  );
});
// interface PropsCNumberInput extends TextFieldProps {
//    children?: React.ReactNode;
// }

const CurrencyField = React.forwardRef(function CurrencyInput({ InputProps, value, ...props }, ref) {
  // console.log('CurrencyField value', value);

  return (
    <TextField
      // size="small"
      ref={ref}
      // value={toString(value)}
      InputProps={{
        inputComponent: TextMaskCustom,
        ...InputProps
      }}
      {...(value && { value: toString(value) })}
      // size="small"
      {...props}
    />
  );
});

export default CurrencyField;
